import { render, staticRenderFns } from "./DeptPositionList.vue?vue&type=template&id=42f9c7f2&"
import script from "./DeptPositionList.vue?vue&type=script&lang=js&"
export * from "./DeptPositionList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports